import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@arnsbogroup/react-voicearchive'
import Icon from 'components/Icon'
import TeamUserCard from './../TeamUserCard'
import messages from "./messages";
import {FormattedMessage, useIntl} from "react-intl";

const Team = ({ editable = false, onRemoved, onAdded, users, customer: { uid, name, contacts = [] } = {} }) => {
  const [editing, setEditing] = useState(false)
  const { formatMessage } = useIntl()

  return (
    <React.Fragment>
      <div className="pb-5 border-b border-gray-200 md:flex md:items-center md:justify-between">
        <div className="flex-1 min-w-0">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            { name }
          </h3>

          <p className="mt-2 max-w-4xl text-sm text-gray-500 space-x-4">
            <span>{ contacts.length } <FormattedMessage {...messages.contacts}/></span>
            <Link to="/company/team" className="text-primary space-x-2">
              <Icon icon="long-arrow-left" />
              <span><FormattedMessage {...messages.back}/></span>
            </Link>
          </p>
        </div>
        <div className="mt-4 flex md:mt-0 md:ml-4">
          { editing ? (
            <Button variant="outline" onClick={() => setEditing(false)}>
              <FormattedMessage {...messages.finish} />
            </Button>
          ) : (
            <Button onClick={() => setEditing(true)} disabled={!editable}>
              <FormattedMessage {...messages.edit} />
            </Button>
          ) }
        </div>
      </div>
      <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 mt-6">
        { contacts.map((props) => (
          <TeamUserCard key={props.uid} {...props} onRemoved={editing ? () => onRemoved(uid, props) : undefined} />
        )) }

        { editing && users.map((props) => (
          <TeamUserCard key={props.uid} {...props} onAdded={() => onAdded(uid, props)} />
        )) }
      </ul>
    </React.Fragment>
  )
}

export default Team
